import { createContext, useCallback, useContext, useState, ReactNode, useEffect } from 'react'
import { useLocation } from '@reach/router'
import { TipoEscritos } from 'src/contexts/consts'
import { TipoMensaje, TipoMensajeURLPath } from 'src/enums/EscritosLegales'

export const TipoMensajeContext = createContext({})

export const TipoMensajeContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [tipoMensaje, setTipoMensaje] = useState<null | TipoMensaje>(null)
  const { pathname } = useLocation()
  const [isMonitorio, setIsMonitorio] = useState<boolean>(false)

  function setTipoMensajeOnLoadPage(pathName: string) {
    setIsMonitorio(false)
    const splitUrl = pathName.split('/')
    const tipoEscrito = splitUrl[splitUrl.length - 1]
    switch (tipoEscrito) {
      case TipoMensajeURLPath.TRAMITE:
        return setTipoMensaje(TipoMensaje.ESCRITO)
      case TipoMensajeURLPath.ASUNTO:
        return setTipoMensaje(TipoMensaje.INICIADOR_ASUNTO)
      case TipoMensajeURLPath.EJECUCION:
        return setTipoMensaje(TipoMensaje.INICIADOR_EJECUCION)
      case TipoMensajeURLPath.QUEJA:
        return setTipoMensaje(TipoMensaje.RECURSO_QUEJA)
      case TipoMensajeURLPath.MONITORIO:
        setIsMonitorio(true)
        return setTipoMensaje(TipoMensaje.MONITORIO)
      case TipoMensajeURLPath.SENTENCIA:
        return setTipoMensaje(TipoMensaje.INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME)
      case TipoMensajeURLPath.PERSONACION:
        return setTipoMensaje(TipoMensaje.PERSONACION)
      default:
        return ''
    }
  }

  const getRoute = (tipoMensaje: TipoMensaje) => {
    switch (tipoMensaje) {
      case TipoMensaje.ESCRITO:
        return TipoMensajeURLPath.TRAMITE
      case TipoMensaje.INICIADOR_ASUNTO:
        return TipoMensajeURLPath.ASUNTO
      case TipoMensaje.INICIADOR_EJECUCION:
        return TipoMensajeURLPath.EJECUCION
      case TipoMensaje.RECURSO_QUEJA:
        return TipoMensajeURLPath.QUEJA
      case TipoMensaje.MONITORIO:
        return TipoMensajeURLPath.MONITORIO
      case TipoMensaje.INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME:
        return TipoMensajeURLPath.SENTENCIA
      case TipoMensaje.PERSONACION:
        return TipoMensajeURLPath.PERSONACION
      default:
        return TipoMensajeURLPath.TRAMITE
    }
  }

  useEffect(() => {
    const found = TipoEscritos.find(tipoMensaje => pathname.includes(tipoMensaje))
    if (found) {
      setTipoMensajeOnLoadPage(pathname)
    }
  }, [pathname])

  const changeTipoMensaje = useCallback((tipo: TipoMensaje | null) => {
    setTipoMensaje(tipo)
  }, [])

  return (
    <TipoMensajeContext.Provider value={{ tipoMensaje, changeTipoMensaje, getRoute, isMonitorio }}>
      {children}
    </TipoMensajeContext.Provider>
  )
}

export function useTipoMensajeContext(): any {
  return useContext(TipoMensajeContext)
}
